function getAlternatePlate(detection: NonNullable<VideoStreamEvent['metadata']>['detection'], plate?: string): string | undefined {
  return detection?.plate?.props?.plate?.find(
    (candidate) => candidate.value.toLowerCase() !== plate?.toLowerCase(),
  )?.value ??
    detection?.candidates?.find(
      (candidate) => candidate.plate.toLowerCase() !== plate?.toLowerCase(),
    )?.plate;
}

export default getAlternatePlate;
